import Logo from "images/welcome-logo.png";

function LoginHeader() {
  return (
    <div className="sm:mx-auto sm:w-full sm:max-w-md">
      <img
        className="mx-auto h-[220px] w-auto"
        src={Logo}
        alt="Toulouse-eco Logo"
      />
    </div>
  );
}

export default LoginHeader;
